// extracted by mini-css-extract-plugin
export var errorIcon = "StreamPlayerWithLoader-module--errorIcon--93383";
export var errorMessage = "StreamPlayerWithLoader-module--errorMessage--56289";
export var loading = "StreamPlayerWithLoader-module--loading--143a2";
export var stream = "StreamPlayerWithLoader-module--stream--981ad";
export var streamError = "StreamPlayerWithLoader-module--streamError--aeaef";
export var streamErrorButton = "StreamPlayerWithLoader-module--streamErrorButton--85b08";